// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import Debit from '@deere/cps-it.warranty-model-factory/lib/debit';
import {getDefaultState} from '../state';

const updateDebitData = (state, action) =>
    Debit.update(state, {
        $merge: action.debit
    });

const updatePercentageValue = (state, action) =>

    Debit.update(state, {
        $merge: action.percentageValue
    });

const resetPercentageDebit = state => Debit.update(state, {
    $merge: getDefaultState().debit
});

const updatePercentageDebitComments = (state, action) =>
    Debit.update(state, {
        reasonForDebit: {$set: action.comments}
    });

const updateDebitType = (state, action) =>
    Debit.update(state, {
        debitType: {$set: action.debitType}
    });

export default (state = getDefaultState().debit, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_PERCENTAGE_DEBIT]: resetPercentageDebit,
        [actions.UPDATE_TCSM_PERCENTAGE_DEBIT_COMMENTS]: updatePercentageDebitComments,
        [actions.UPDATE_TCSM_PERCENTAGE_DEBIT_DATA]: updateDebitData,
        [actions.UPDATE_TCSM_PERCENTAGE_DEBIT_TYPE]: updateDebitType,
        [actions.RESET_TCSM_PERCENTAGE_DEBIT]: resetPercentageDebit,
        [actions.UPDATE_TCSM_PERCENTAGE_DEBIT_VALUE]: updatePercentageValue
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/reducers/debit.js